// import { Typogaphy } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'
import SubHeaders from '@/components/Headers/SubHeaders'
import { paths } from '@/utils/path'
import NavigationCards from '../NavigationCards'
import ComingSoon from '@/components/ComingSoon'

const WorkingProcess = () => {
    const { t } = useTranslation()

    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    { path: paths.account, title: t('account') },
                    { path: '', title: t('account-working-process') },
                ]}
            />

            <NavigationCards>
                <ComingSoon
                    featureName="account-working-process"
                    description="career-tracking-coming-soon"
                    showBackButton={false}
                />
            </NavigationCards>
        </div>
    )
}

export default WorkingProcess
